import { PhotoReviewModel } from '../../model/photo-review.model';

export const OrderCI_PHOTOREVIEW_STATE_PATH = 'photoreview';

export class PhotoReviewStateModel {
	currentPhotos?: PhotoReviewModel[];

	constructor() {
		this.currentPhotos = [];
	}
}
